import { LOAD_STATE } from '@/shared/types'
import type { HotSeriesResponse } from '@/server/types'
import { getHotSeriesRankApi } from '@/server'

export function logicHotSeriesRank() {
  const state = ref(LOAD_STATE.INIT)
  const data = ref<HotSeriesResponse[]>([])

  async function getRankData() {
    const res = await useLoadState({
      state,
      key: `热门车系排行榜`,
      onlyClient: true,
      fn: () => getHotSeriesRankApi(),
    })

    if (res && res.data)
      data.value = res.data
  }

  return {
    state,
    data,
    getRankData,
  }
}
